import { themeIsValid, type Theme } from './types'

export const themeLocalStorageKey = 'payload-theme'

export const defaultTheme = 'light'

export const getImplicitPreference = (): Theme | null => {
  const mediaQuery = '(prefers-color-scheme: dark)'
  const mql = window.matchMedia(mediaQuery)
  const hasImplicitPreference = typeof mql.matches === 'boolean'

  if (hasImplicitPreference) {
    return mql.matches ? 'dark' : 'light'
  }

  return null
}

/** Preferência persistida no cliente (localStorage → sistema → fallback SSR). */
export function resolveClientTheme(fallback: Theme): Theme {
  if (typeof window === 'undefined') return fallback

  /*
   * 🔴 try/catch obrigatório (23/08/2026): esta função roda DURANTE o render de hidratação do
   * ThemeProvider. Em navegador com storage bloqueado (modo privado/iframe restrito),
   * `localStorage.getItem` lança SecurityError — e uma exceção aqui derrubava a árvore inteira
   * para esse leitor. O `themeBootScript` já engolia o erro; o provider tinha ficado para trás.
   */
  try {
    const fromStorage = window.localStorage.getItem(themeLocalStorageKey)
    if (themeIsValid(fromStorage)) {
      return fromStorage
    }
  } catch {
    /* storage inacessível — cai na preferência do sistema */
  }

  try {
    return getImplicitPreference() ?? fallback
  } catch {
    return fallback
  }
}
